import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import {
	Select,
	SelectTrigger,
	SelectValue,
	SelectContent,
	SelectItem,
} from "../ui/select";
import StarIcon from "../../assets/svgs/common/star.svg";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";

type FormSelectProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label: string;
	placeholder: string;
	required?: boolean;
	nullOption?: { label: string };
	options: { value: string; label: string }[];
	disabled?: boolean;
	onOpenChange?: () => void;
};

export const FormSelect = <T extends FieldValues>({
	name,
	form,
	label,
	placeholder,
	required,
	options,
	disabled = false,
	onOpenChange,
}: FormSelectProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label} {required && <StarIcon />}
					</FormLabel>
					<Select  onOpenChange={onOpenChange}  onValueChange={field.onChange} value={field.value || ""}>
						<FormControl>
							<SelectTrigger 
								className={`py-6 pl-6 h-16 ${
									field.value ? "text-primary" : "text-secondary"
								} `}
							>
								<SelectValue  placeholder={placeholder} />
							</SelectTrigger>
						</FormControl>
						<SelectContent className="relative font-gliroy_regular font-semibold">
							{options.map((option) => (
								<SelectItem
									key={option.value}
									value={option.value}
									disabled={disabled}
								>
									{option.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</FormItem>
			)}
		/>
	);
};
